import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import MobileChecker from "../../shared/utils/MobileChecker";

import { segmentEventTracker } from '../../../utils/SegmentEventTracker';
import { PageViewName } from '../../shared/constants/SegmentEvents';

import Layout from '../../shared/components/layouts/MainLayout';
import MobileNav from './MobileNav';
import AccountLogic from './Logic'
import { fetchCreditLimit } from '../../CreditLimit/actions';
import { fetchUpcomingPayments } from '../../loans/actions';
import { PaymentStatus } from '../../shared/utils/PaymentStatus';

class Account extends Component {
  get isMobile() {
    return MobileChecker()
  }

  get overduePayments() {
    const filters = [PaymentStatus.OVERDUE]
    const {upcomingPayments = []} = this.props
    return upcomingPayments
            .filter(loanPlan => filters.includes(loanPlan.status))
            .filter(loanPlan => loanPlan.payment.total > 0)
  }

  componentDidMount() {
    segmentEventTracker.trackPageView(PageViewName.MY_ACCOUNT_VIEWED);
    this.props.fetchCreditLimit();
    this.props.fetchUpcomingPayments();
  }

  render() {
    const {loading, loadingUpcomingPayments} = this.props
    const {creditLimit, push, user} = this.props
    return (
      <Layout gridClassName='_marginTop--xxlarge-tabletUp --narrow'>
        <AccountLogic
          creditLimit={creditLimit}
          overdueRepayments={this.overduePayments}
          loading={loading || loadingUpcomingPayments}
          push={push}
          user={user}
        />
        {this.isMobile && <MobileNav />}
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    company: state.company,
    creditLimit: state.creditLimit,
    loading: state.shared.ui.loading.creditLimit,
    loadingUpcomingPayments: state.shared.ui.loading.upcomingPayments,
    upcomingPayments: state.loans.upcomingPayments,
    user: state.user,
  }
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    fetchCreditLimit: () => dispatch(fetchCreditLimit()),
    fetchUpcomingPayments: () => dispatch(fetchUpcomingPayments()),
    push: url => dispatch(push(url)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Account);



// WEBPACK FOOTER //
// ./src/features/account/containers/Account.js